import { render, staticRenderFns } from "./ModalTabelaProfissionaisEquipesMedicas.vue?vue&type=template&id=67dc4114&scoped=true"
import script from "./ModalTabelaProfissionaisEquipesMedicas.vue?vue&type=script&lang=ts"
export * from "./ModalTabelaProfissionaisEquipesMedicas.vue?vue&type=script&lang=ts"
import style0 from "./ModalTabelaProfissionaisEquipesMedicas.vue?vue&type=style&index=0&id=67dc4114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc4114",
  null
  
)

export default component.exports